module.exports = __webpack_public_path__ + "img/f-thermometer-img3-2.b7a46429.png";